import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import { SMPrecipitation } from '@/components/Charts/SMPrecipitation';
import { GraphFact } from '@/components/Charts/types';

import { NoPlotData } from '../NoPlotData';

export const SMPrecipitationGraphTile = ({ graphData }: { graphData: GraphFact[] | null | undefined }) => {
  const { t } = useTranslation();

  const noChartData = !graphData?.length;

  if (noChartData) {
    return <NoPlotData />;
  }

  const chartData = [...graphData];

  return (
    <Stack spacing={6} className='items-center justify-center px-1 py-6 lg:items-start lg:p-6 lg:pl-1'>
      <ChartHeading
        heading={t('shared.ncaDetail.details.water.labels.historicalGraphHeadlinePrecipitation')}
        popover={{
          title: t('shared.ncaDetail.details.water.explainers.historicalDataPrecipitation.title'),
          body: t('shared.ncaDetail.details.water.explainers.historicalDataPrecipitation.body'),
        }}
        className='w-full px-6 sm:px-0'
      />
      <SMPrecipitation data={chartData} className='relative' />
    </Stack>
  );
};
